<mat-card [ngClass]="cardClass()">
  @if (showHeader()) {
    <mat-card-header class="card-header d-flex align-items-center" [ngClass]="headerClass()">
      <div class="d-flex align-items-center">
        <!-- Icono -->
        <div
          class="avatar avatar-s rounded-circle d-flex align-items-center justify-content-center"
          [ngStyle]="{
            'border-radius': '50%',
            'background-color': BackgroundColor(),
            color: TextColor()
          }"
        >
          <i *ngIf="cardIcon" class="{{ cardIcon() }}"></i>
        </div>
      </div>

      <!-- Título con margen izquierdo personalizado -->
      <div class="f-16 f-w-600" style="margin-left: 1rem; margin-top: 0.5rem">
        {{ cardTitle() }}
        <ng-container *ngTemplateOutlet="headerTitleTemplate()"></ng-container>
      </div>

      <ng-container *ngTemplateOutlet="headerOptionsTemplate()"></ng-container>
    </mat-card-header>
  }
  @if (showContent()) {
    <mat-card-content [style.padding.px]="padding()">
      <ng-content></ng-content>
    </mat-card-content>
  }
  @if (actionTemplate) {
    <mat-card-actions [ngClass]="actionClass()">
      <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
    </mat-card-actions>
  }
</mat-card>
